import React, { useState } from 'react';
import logo from '../../assets/images/logo.png';
import MyOrders from '../MyOrders/MyOrders';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    useParams,
    useRouteMatch
} from "react-router-dom";
import MakeAdmin from '../MakeAdmin/MakeAdmin';
import useAuth from '../../hooks/useAuth';
import AdminRoute from '../AdminRoute/AdminRoute';
import GiveReview from '../GiveReview/GiveReview';
import Payment from '../Payment/Payment';
import ManageProducts from '../ManageProducts/ManageProducts';
import ManageOrders from '../ManageOrders/ManageOrders';
import AddProduct from '../AddProduct/AddProduct';

const Dashboard = () => {
    const [status, setStatus] = useState(false);
    const { logOut, admin } = useAuth();
    let { path, url } = useRouteMatch();
    return (
        <div className="container-fluid">
            <div className="row flex-nowrap">
                <div style={{ border: '1px solid grey' }} className="col-auto col-md-3 col-xl-2 px-sm-2 px-0">
                    <div className="d-flex flex-column align-items-center align-items-sm-start px-3 pt-2 text-white min-vh-100">
                        <ul className="nav nav-pills flex-column mb-sm-auto mb-0 align-items-center align-items-sm-start" id="menu">
                            <li className="nav-item">
                                <Link to='/home'><img className='w-25' src={logo} alt="" /></Link>
                            </li>
                            <li>
                                <Link to={`${url}`} className="nav-link px-0 align-middle">
                                    <i class="fas fa-list"></i> <span className="ms-1 d-none d-sm-inline">My Orders</span></Link>
                            </li>
                            {
                                admin && <div>
                                    <li>
                                        <Link to={`${url}/makeadmin`} className="nav-link px-0 align-middle">
                                            <i class="fas fa-user-shield"></i> <span className="ms-1 d-none d-sm-inline">Make Admin</span></Link>
                                    </li>
                                    <li>
                                        <Link to={`${url}/manageproducts`} className="nav-link px-0 align-middle">
                                            <i class="fas fa-car"></i> <span className="ms-1 d-none d-sm-inline">Manage Products</span></Link>
                                    </li>
                                    <li>
                                        <Link to={`${url}/manageorder`} className="nav-link px-0 align-middle">
                                            <i class="fas fa-shopping-cart"></i> <span className="ms-1 d-none d-sm-inline">Manage Orders</span></Link>
                                    </li>
                                    <li>
                                        <Link to={`${url}/addproduct`} className="nav-link px-0 align-middle">
                                            <i class="fas fa-plus"></i> <span className="ms-1 d-none d-sm-inline">Add a Product</span></Link>
                                    </li>
                                </div>
                            }

                            <li>
                                <Link to={`${url}/review`} className="nav-link px-0 align-middle">
                                    <i class="fas fa-star"></i> <span className="ms-1 d-none d-sm-inline">Give Review</span></Link>
                            </li>
                            <li>
                                <Link to={`${url}/pay`} className="nav-link px-0 align-middle">
                                    <i class="fas fa-money-check"></i> <span className="ms-1 d-none d-sm-inline">Payment</span></Link>
                            </li>
                            <li>
                                <button onClick={logOut} className="nav-link px-0 align-middle">
                                    <i class="fas fa-sign-out-alt"></i> <span className="ms-1 d-none d-sm-inline">Log Out</span></button>
                            </li>
                        </ul>
                        <hr />
                    </div>
                </div>
                <div className="col py-3">
                    <Switch>
                        <Route exact path={path}>
                            <MyOrders />
                        </Route>
                        <AdminRoute path={`${path}/makeadmin`}>
                            <MakeAdmin />
                        </AdminRoute>
                        <AdminRoute path={`${path}/review`}>
                            <GiveReview />
                        </AdminRoute>
                        <AdminRoute path={`${path}/manageproducts`}>
                            <ManageProducts />
                        </AdminRoute>
                        <AdminRoute path={`${path}/manageorder`}>
                            <ManageOrders />
                        </AdminRoute>
                        <AdminRoute path={`${path}/addproduct`}>
                            <AddProduct />
                        </AdminRoute>
                        <Route path={`${path}/pay`}>
                            <Payment />
                        </Route>
                    </Switch>
                </div>
            </div>
        </div>
    );
};

export default Dashboard;

{/* <MyOrders /> */ }